import angular from "angular";

angular
    .module('app')
    .component('quizPassPage', {
        template: require('./quiz-pass-page.html'),
        controller: ['$http', '$rootScope', controller],
        bindings: {
            questions: '<',
            lessonId: '@',
            courseId: '@',
            quizId: '@',
        }
    });

function controller($http, $rootScope) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.questions.forEach(q => {
            q.selected = q.type == 'multiple' ? {} : null;
        })
    };

    $ctrl.save = function () {
        let params = {
            questions: $ctrl.questions,
        }

        $http.post(`/cabinet/courses/${$ctrl.courseId}/lesson/${$ctrl.lessonId}/quiz/${$ctrl.quizId}`, params)
            .then(
                function (resolve) {
                    $rootScope.$emit('quizFinished', {
                        quizResult: resolve.data,
                    });
                }
            )
    }
}